import { CurrencyFormat, Icon, Spinner } from '@/components/generic';
import { useGetInfoCard } from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

import { useCardContext } from '../context/useCardContext';

const Statistics = () => {
  const { t } = useTranslation();
  const { selectedCard, isLoading } = useCardContext();
  const selectedCardId = selectedCard?.id || 0;
  const { cardInfo, isLoading: isLoadingCardInfo } = useGetInfoCard({
    cardId: selectedCardId,
  });

  return (
    <div className='card'>
      <div className='flex gap-8 flex-wrap p-2 max-2xl:gap-6 max-lg:p-3 max-md:flex-col'>
        <div className='flex-1 pr-6 border-r border-shade-07/10 last:border-0 max-4xl:nth-3:hidden max-lg:nth-2:hidden max-md:pr-0 max-md:border-r-0 max-md:border-b max-md:pb-6 max-md:last:pb-0'>
          <div className='flex items-center justify-center size-10 mb-2 rounded-full bg-b-surface1 max-md:mb-4'>
            <Icon className={`fill-t-primary`} name={'wallet'} />
          </div>
          <div className='flex items-center gap-2 mb-2'>
            <div className='text-sub-title-1'>{t('cards.balance')}</div>
            {selectedCard && (
              <div className='text-caption text-t-secondary bg-b-surface2 px-2 py-1 rounded-lg'>
                {selectedCard.name}
              </div>
            )}
          </div>
          {isLoading || isLoadingCardInfo ? (
            <Spinner />
          ) : (
            <CurrencyFormat
              className='text-h4 max-xl:text-h3 max-lg:text-h2 max-md:text-h3'
              value={Number(cardInfo?.balanceInfo?.amount || '0')}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Statistics;
